export const pushIfNotEmpty = (
  arr: { label: string; value: string; columnSize: any }[],
  label: string,
  value: string,
  columnSize?: any
) => {
  if (value && value !== '') arr.push({ label, value, columnSize });
};
